<script lang="ts" setup>
import type { TeleportProps } from 'vue';

import { provideListboxPortalContext } from '@/kasten-components/components/KaListbox/context';

const props = defineProps<TeleportProps>();

provideListboxPortalContext({ teleportProps: props });
</script>
<template>
  <slot />
</template>
